import React from "react";
import PropTypes from "prop-types";
import moment from "moment";

import { DATETIME } from "../../../../utils/dateFormats";


const RequestProcessed = ({ request }) => [
  <tr key={1}>
    <th>Status</th>
    <td className={request.approved ? "success" : request.approved === false ? "danger" : "warning"}>
      {request.approved ? "Approved" : request.approved === false ? "Denied" : "Expired"}
    </td>
  </tr>,
  <tr key={2}>
    <th>Processed By</th>
    <td>
      {request.processed_by_user_id ? (
        <a
          href={`/users/${request.processed_by_user_id}`}
          className="styled-link"
        >
          {[request.processed_by_first_name, request.processed_by_last_name].join(" ")}
        </a>
      ) : (
        <em>This sub request was processed automatically by DigiQuatics System</em>
      )}
    </td>
  </tr>,
  <tr key={3}>
    <th>Processed On</th>
    <td>{moment(request.processed_on).format(DATETIME)}</td>
  </tr>,
  <tr key={4}>
    <th>Manager Note</th>
    <td>{request.admin_note ? request.admin_note : "-"}</td>
  </tr>
];


RequestProcessed.propTypes = {
  request: PropTypes.object.isRequired
};

export default RequestProcessed;
